// src/lib/firebase.js
// Config comes from .env now instead of being hardcoded — when you stand up
// a new Firebase project, drop its config into .env and nothing here needs
// to change. Get these values from:
// Firebase Console → Project Settings → Your apps → SDK setup and config.
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  throw new Error(
    "Missing Firebase config — copy .env.example to .env and fill in the REACT_APP_FIREBASE_* values from your Firebase project settings."
  );
}

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);
// By default a screenshot upload retries for 10 MINUTES before giving up,
// which would leave the time tracker hanging on a dead connection. Fail
// after 30s instead — the screenshot is then kept on the device and uploaded
// when the connection is back (see lib/offlineQueue.js).
storage.maxUploadRetryTime = 30000;
storage.maxOperationRetryTime = 15000;
export default app;
